import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useEffect, useState } from 'react';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';

const G: React.FC = () => {
    const { t } = useLang('shp3');
    const [enter, setEnter] = useState({
        label: false,
        title: false,
        desc: false,
    });
    const webpOrJpg = useWebpOrJpg('#shp3-G');
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneGArr: any[] = [];
            ['label', 'title', 'desc'].forEach((item: string) => {
                const dom: HTMLElement | null = document.querySelector(`.shp3-G .${item}-ani`);
                if (dom) {
                    sceneGArr.push(
                        AniContainer.create({
                            triggerElement: '.shp3-G .info',
                            triggerHook: 1,
                            offset: dom.offsetHeight,
                            duration: '80%',
                            onEnter: () => {
                                setEnter((prev) => ({
                                    ...prev,
                                    [item]: true,
                                }));
                            },
                            // onLeave: () => {
                            //     setEnter((prev) => ({
                            //         ...prev,
                            //         [item]: false,
                            //     }));
                            // },
                        }),
                    );
                }
            });
            return () => {
                sceneGArr.forEach((item) => item.destroy());
            };
        }
    }, []);

    return (
        <section className={`${css.section} shp3-G GtmModuleData-section`} id="shp3-G" data-section-id={'shp3-G'} data-section-title={t('G_title')}>
            <div className="item-img">
                <EcoImg
                    pc={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1760151736410/shp3-pc_Compatible%20with%20High-Power%20Generators.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1760151760637/shp3-pc_Compatible.webp',
                    )}
                    h5={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1760151736120/shp3-m_Compatible%20with%20High-Power%20Generators.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1760151760957/shp3-m_Compatible.webp',
                    )}
                />
            </div>
            <div className="info">
                <div className="box">
                    <div className="label-ani">
                        <p className={`label ${enter.label ? 'enter' : ''}`}>{t('G_label')}</p>
                    </div>
                    <div className="title-ani">
                        <p className={`title ${enter.title ? 'enter' : ''}`}>{t('G_title')}</p>
                    </div>
                </div>
                <div className="desc-ani">
                    <p className={`desc ${enter.desc ? 'enter' : ''}`}>
                        {t.rich('G_desc', {
                            h: (a: string) => <span className="white">{a}</span>,
                        })}
                    </p>
                </div>
            </div>
        </section>
    );
};

export default G;
